var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z",
    stroke: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77778 19H13.2222C16.3433 19 17.9038 19 19.0248 18.2646C19.51 17.9462 19.9267 17.5371 20.251 17.0607C21 15.9601 21 14.4279 21 11.3636C21 8.2994 21 6.76721 20.251 5.6666C19.9267 5.19014 19.51 4.78104 19.0248 4.46268C18.3044 3.99013 17.4027 3.82123 16.022 3.76086C15.3631 3.76086 14.7959 3.27068 14.6667 2.63636C14.4728 1.68489 13.6219 1 12.6337 1H9.3663C8.37805 1 7.52715 1.68489 7.33333 2.63636C7.20412 3.27068 6.63685 3.76086 5.978 3.76086C4.59733 3.82123 3.69555 3.99013 2.97524 4.46268C2.48995 4.78104 2.07328 5.19014 1.74902 5.6666C1 6.76721 1 8.2994 1 11.3636C1 14.4279 1 15.9601 1.74902 17.0607C2.07328 17.5371 2.48995 17.9462 2.97524 18.2646C4.09624 19 5.65675 19 8.77778 19Z",
    stroke: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H17",
    stroke: "#1C274C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7b885c0b824f3d2c75bce24f55caca1c.svg";
export { ForwardRef as ReactComponent };